/**
 * City-specific SEO content for location landing pages.
 * Each city gets unique introductory copy referencing local geography.
 * Uses "borrow/lend" exclusively — NEVER "rent/rental".
 */

const CITY_SEO_CONTENT = {
  // VIRGINIA
  "Reston, VA": {
    intro: "Paradise Borrowed\u2122 connects neighbors in Reston, Virginia \u2014 in the heart of Fairfax County, just minutes from Dulles International Airport and the Reston Town Center. Whether you\u2019re a resident of Lake Anne or a visitor exploring the W&OD Trail, borrow what you need from people nearby instead of buying items you\u2019ll only use once.",
    geo: "Located in Northern Virginia\u2019s Dulles Technology Corridor, Reston is home to over 60,000 residents and a thriving community of professionals, families, and outdoor enthusiasts."
  },
  "Arlington, VA": {
    intro: "Paradise Borrowed\u2122 brings peer-to-peer borrowing to Arlington, Virginia \u2014 just across the Potomac from Washington, D.C. From Rosslyn and Clarendon to Crystal City and Ballston, borrow household items, tools, cameras, and baby gear from your Arlington neighbors instead of buying new.",
    geo: "Arlington County is one of the most densely populated communities in the D.C. metro area, making it an ideal location for neighbor-to-neighbor lending."
  },
  "Alexandria, VA": {
    intro: "Paradise Borrowed\u2122 serves the historic city of Alexandria, Virginia \u2014 nestled along the Potomac River waterfront just south of Washington, D.C. Whether you\u2019re in Old Town or the West End, borrow what you need from trusted neighbors in your community.",
    geo: "Alexandria\u2019s walkable neighborhoods and tight-knit community make it a natural fit for peer-to-peer borrowing."
  },
  "Richmond, VA": {
    intro: "Paradise Borrowed\u2122 connects lenders and borrowers across Richmond, Virginia \u2014 the capital city on the James River. From the Fan District and Carytown to Short Pump and Shockoe Bottom, borrow gear, tools, and everyday items from fellow Richmonders.",
    geo: "Richmond\u2019s diverse neighborhoods and growing population make it a vibrant hub for the borrowers economy in central Virginia."
  },

  // FLORIDA
  "Miami, FL": {
    intro: "Paradise Borrowed\u2122 serves Miami, Florida \u2014 from South Beach and Wynwood to Coral Gables and Brickell. Whether you\u2019re a local or visiting the Magic City, borrow beach gear, baby equipment, cameras, and more from neighbors instead of overpaying at tourist shops.",
    geo: "As the gateway to Latin America and the Caribbean, Miami welcomes millions of visitors each year \u2014 many of whom need items they didn\u2019t pack."
  },
  "Fort Lauderdale, FL": {
    intro: "Paradise Borrowed\u2122 connects borrowers and lenders in Fort Lauderdale, Florida \u2014 the Venice of America, known for its beaches and inland waterways in Broward County. Borrow what you need from locals instead of buying items you\u2019ll use once.",
    geo: "Fort Lauderdale\u2019s beach culture and visitor traffic make it a prime location for peer-to-peer borrowing."
  },
  "Orlando, FL": {
    intro: "Paradise Borrowed\u2122 brings peer-to-peer borrowing to Orlando, Florida \u2014 the theme park capital of the world in Orange County. Visiting families can borrow baby car seats, strollers, and gear from Orlando residents instead of packing heavy luggage.",
    geo: "With over 75 million visitors annually, Orlando is one of the most-visited cities in the U.S., creating strong demand for temporary item borrowing."
  },
  "Tampa, FL": {
    intro: "Paradise Borrowed\u2122 serves Tampa, Florida \u2014 located on Tampa Bay in Hillsborough County. From Ybor City to South Tampa and the Westshore district, borrow tools, electronics, baby gear, and outdoor equipment from your Tampa neighbors.",
    geo: "Tampa\u2019s waterfront communities and family-friendly neighborhoods make it an ideal market for the borrowers economy."
  },
  "Key West, FL": {
    intro: "Paradise Borrowed\u2122 connects the Key West, Florida community \u2014 at the southernmost point of the continental United States in Monroe County. Borrow snorkel gear, beach equipment, cameras, and more from island locals instead of buying disposable tourist items.",
    geo: "Key West\u2019s island lifestyle and steady flow of visitors create a natural demand for borrowing over buying."
  },

  // NEW YORK
  "New York City, NY": {
    intro: "Paradise Borrowed\u2122 serves New York City \u2014 all five boroughs, from Manhattan and Brooklyn to Queens, the Bronx, and Staten Island. Borrow cameras, tools, party supplies, and baby gear from fellow New Yorkers who live in your neighborhood.",
    geo: "In a city where apartment space is limited, borrowing items from neighbors makes more sense than buying and storing things you rarely use."
  },

  // CALIFORNIA
  "Los Angeles, CA": {
    intro: "Paradise Borrowed\u2122 brings peer-to-peer borrowing to Los Angeles, California \u2014 from Santa Monica and Venice to Downtown L.A. and the Valley. Borrow cameras, outdoor gear, baby equipment, and household items from your L.A. neighbors.",
    geo: "Los Angeles County\u2019s sprawling neighborhoods and creative communities make it a natural hub for the borrowers economy."
  },
  "San Francisco, CA": {
    intro: "Paradise Borrowed\u2122 connects borrowers and lenders across San Francisco, California \u2014 from the Mission and SoMa to Pacific Heights and the Sunset. Borrow tech gear, outdoor equipment, and household items from neighbors in the City by the Bay.",
    geo: "San Francisco\u2019s dense, walkable neighborhoods and sustainability-minded residents are ideal for peer-to-peer borrowing."
  },
  "San Diego, CA": {
    intro: "Paradise Borrowed\u2122 serves San Diego, California \u2014 from La Jolla and Pacific Beach to Gaslamp Quarter and North Park. Borrow surfboards, beach gear, baby equipment, and cameras from your San Diego neighbors.",
    geo: "San Diego\u2019s year-round beach culture and active outdoor community create strong demand for borrowing gear and equipment."
  },

  // MASSACHUSETTS
  "Boston, MA": {
    intro: "Paradise Borrowed\u2122 connects neighbors across Boston, Massachusetts \u2014 from Back Bay and Beacon Hill to South Boston and Cambridge. Borrow tools, electronics, baby gear, and winter equipment from fellow Bostonians.",
    geo: "Boston\u2019s college-town energy and dense neighborhoods make it a natural fit for the borrowers economy in New England."
  },

  // WASHINGTON
  "Seattle, WA": {
    intro: "Paradise Borrowed\u2122 serves Seattle, Washington \u2014 from Capitol Hill and Ballard to Fremont and West Seattle. Borrow camping gear, cameras, tools, and household items from your Seattle neighbors.",
    geo: "Seattle\u2019s outdoor culture and environmentally conscious residents make it an ideal community for peer-to-peer borrowing."
  },

  // OHIO
  "Columbus, OH": {
    intro: "Paradise Borrowed\u2122 brings peer-to-peer borrowing to Columbus, Ohio \u2014 the state capital and largest city, home to The Ohio State University. Borrow tools, electronics, party supplies, and more from your Columbus neighbors.",
    geo: "Columbus\u2019s growing population and vibrant neighborhoods create a strong community for the borrowers economy in the Midwest."
  },

  // ARIZONA
  "Phoenix, AZ": {
    intro: "Paradise Borrowed\u2122 connects lenders and borrowers in Phoenix, Arizona \u2014 the Valley of the Sun in Maricopa County. From Scottsdale and Tempe to Mesa and Chandler, borrow outdoor gear, cameras, tools, and baby equipment from your neighbors.",
    geo: "Phoenix\u2019s sprawling metro area and year-round sunshine make it a great market for borrowing outdoor and recreational gear."
  },
  "Scottsdale, AZ": {
    intro: "Paradise Borrowed\u2122 serves Scottsdale, Arizona \u2014 known for its resorts, golf courses, and vibrant arts scene in the East Valley. Borrow cameras, outdoor gear, party supplies, and more from Scottsdale locals.",
    geo: "Scottsdale\u2019s resort community and visitor traffic create natural demand for temporary item borrowing."
  },

  // MARYLAND / DC
  "Baltimore, MD": {
    intro: "Paradise Borrowed\u2122 connects neighbors in Baltimore, Maryland \u2014 Charm City, home to the Inner Harbor, Fells Point, and Federal Hill. Borrow tools, baby gear, cameras, and household items from fellow Baltimoreans.",
    geo: "Baltimore\u2019s tight-knit neighborhoods and diverse communities make it a strong market for peer-to-peer borrowing."
  },
  "Washington DC, DC": {
    intro: "Paradise Borrowed\u2122 serves Washington, D.C. \u2014 the nation\u2019s capital, from Georgetown and Dupont Circle to Capitol Hill and Adams Morgan. Borrow cameras, outdoor gear, tools, and baby equipment from your D.C. neighbors.",
    geo: "D.C.\u2019s transient population and dense neighborhoods create a natural demand for borrowing over buying."
  },
};

/**
 * Get unique city SEO content. Falls back to generated content if no custom entry exists.
 */
export function getCitySEOContent(cityName, stateAbbrev, stateName) {
  const key = `${cityName}, ${stateAbbrev}`;
  const custom = CITY_SEO_CONTENT[key];

  if (custom) return custom;

  // Generate unique-ish content from city/state data
  return {
    intro: `Paradise Borrowed\u2122 connects neighbors in ${cityName}, ${stateName}. Borrow household items, tools, cameras, baby gear, sports equipment, and more from people in your community. Whether you need something for a weekend project, a family trip, or everyday life \u2014 find it nearby without buying new.`,
    geo: `${cityName} is part of a growing network of communities across ${stateName} where peer-to-peer borrowing is helping neighbors save money, reduce waste, and build connections.`
  };
}

/**
 * SEO-safe item categories for location pages.
 * Uses "borrow" terminology exclusively.
 */
export const SEO_BORROW_CATEGORIES = [
  { name: "Beach Gear", desc: "Surfboards, beach chairs, umbrellas, coolers" },
  { name: "Baby & Kids", desc: "Car seats, strollers, cribs, high chairs" },
  { name: "Photography & Video", desc: "DSLR cameras, GoPros, lenses, tripods" },
  { name: "Tools & Hardware", desc: "Power drills, saws, ladders, tool kits" },
  { name: "Outdoor & Sports", desc: "Kayaks, bikes, camping gear, fishing rods" },
  { name: "Electronics & Gadgets", desc: "Speakers, projectors, drones, tablets" },
  { name: "Household Items", desc: "Kitchen appliances, vacuums, furniture" },
  { name: "Party & Events", desc: "Tents, tables, speakers, decorations" },
];
